import React, { useContext, useState, useEffect } from "react";
import { AuthContext, IntlContext, ListContext } from "context";
import List from "./List";
import { ListWrapper } from "components/List";
import { ListProvider } from "context/List/Context";
import dataFetcher, { BookingStatus } from "hooks/booking";
import { Role } from "types/user";
import useQueryString from "helpers/useQueryString";
import Button from "ui/Button";
import Footer from "components/Layout/Main/Footer";

const BookingListComponent: React.FC = () => {
    const intl = useContext(IntlContext);
    const { currentRole } = useContext(AuthContext);
    const { changeFetcherParams } = useContext(ListContext);
    const queryString = useQueryString();
    const [bookingsPendingTotal, setBookingsPendingTotal] = useState(0);
    const [bookingsProgressTotal, setBookingsProgressTotal] = useState(0);
    const [bookingsValidateTotal, setBookingsValidateTotal] = useState(0);
    const [bookingsClosedTotal, setBookingsClosedTotal] = useState(0);

    const handleOnClickFilters = (bookingStatus: BookingStatus | undefined) => {
        if (bookingStatus) {
            queryString.set("filter_status", bookingStatus);
            queryString.values.filter_status = bookingStatus;
        } else {
            queryString.reset();
            delete queryString.values.filter_status;
        }

        changeFetcherParams(queryString.values);
        refreshCountStatus();
    };

    const refreshCountStatus = () => {
        const promise = dataFetcher.all();
        promise
            .then((data) => {
                let pending = 0, progress = 0, validate = 0, closed = 0;
                data.forEach((booking) => {
                    switch(booking.status) {
                        case BookingStatus.PENDING:
                            pending++;
                            break;
                        case BookingStatus.IN_PROGRESS:
                            progress++;
                            break;
                        case BookingStatus.TO_VALIDATE:
                            validate++;
                            break;
                        case BookingStatus.CLOSED:
                            closed++;
                            break;
                    }
                });

                setBookingsPendingTotal(pending);
                setBookingsProgressTotal(progress);
                setBookingsValidateTotal(validate);
                setBookingsClosedTotal(closed);
            });
    }

    useEffect(() => {
        if(bookingsPendingTotal === 0 || bookingsProgressTotal === 0 || bookingsValidateTotal === 0 || bookingsClosedTotal === 0)
            refreshCountStatus();
    })

    return (
        <React.Fragment>
            <div className="tabs">
                <Button
                    className={
                        "btn btn--primary btn--square tabs-tab " + (queryString.values.filter_status === BookingStatus.PENDING ? "active" : "")
                    }
                    onClick={() => handleOnClickFilters(BookingStatus.PENDING)}
                >
                    <span className="tabs-tab__content">
                        {intl.formatMessage("booking.list.filters.label.pending")}
                        {bookingsPendingTotal ? " (" + bookingsPendingTotal +")" : ""}
                    </span>
                </Button>
                <Button
                    className={
                        "btn btn--primary btn--square tabs-tab " + (queryString.values.filter_status === BookingStatus.IN_PROGRESS ? "active" : "")
                    }
                    onClick={() => handleOnClickFilters(BookingStatus.IN_PROGRESS)}
                >
                    <span className="tabs-tab__content">
                        {intl.formatMessage("booking.list.filters.label.in_progress")}
                        {bookingsProgressTotal ? " (" + bookingsProgressTotal +")" : ""}
                    </span>
                </Button>
                <Button
                    className={
                        "btn btn--primary btn--square tabs-tab " + (queryString.values.filter_status === BookingStatus.TO_VALIDATE ? "active" : "")
                    }
                    onClick={() => handleOnClickFilters(BookingStatus.TO_VALIDATE)}
                >
                    <span className="tabs-tab__content">
                        {currentRole === Role.PROVIDER ? intl.formatMessage("booking.list.filters.label.waiting") : intl.formatMessage("booking.list.filters.label.to_validate")}
                        {bookingsValidateTotal > 0 ? " (" + bookingsValidateTotal +")" : ""}
                        {bookingsValidateTotal > 0 && (
                            <span className="text-color--danger" style={{marginLeft: "2px"}}>!</span>
                        )}
                    </span>
                </Button>
                <Button
                    className={
                        "btn btn--primary btn--square tabs-tab " + (queryString.values.filter_status === BookingStatus.CLOSED ? "active" : "")
                    }
                    onClick={() => handleOnClickFilters(BookingStatus.CLOSED)}
                >
                    <span className="tabs-tab__content">{intl.formatMessage("booking.list.filters.label.closed")}</span>
                </Button>
                <Button
                    className={"btn btn--primary btn--square tabs-tab " + (!queryString.values.filter_status ? "active" : "")}
                    onClick={() => handleOnClickFilters(undefined)}
                >
                    <span className="tabs-tab__content">{intl.formatMessage("booking.list.filters.label.all")}</span>
                </Button>
            </div>
            <ListWrapper>
                <List />
            </ListWrapper>
        </React.Fragment>
    );
};

const BookingList: React.FC = () => {
    const { currentRole } = useContext(AuthContext);

    return (
        <React.Fragment>
            <div className="dashboard-page">
                <div className="block-header">
                    <div className="container">
                        <h1 className="block-header__title">
                            Mes <span>
                            {currentRole === Role.PROVIDER ? (
                                "missions"
                            ) : (
                                "réservations"
                            )}
                            </span>
                        </h1>
                    </div>
                </div>
                <div className="container">
                    <div className="register__container contact">
                        <ListProvider
                            dataFetcher={dataFetcher.all}
                            defaultFetcherParams={{
                                order: "created_at",
                                direction: "desc",
                            }}
                        >
                            <BookingListComponent />
                        </ListProvider>
                    </div>
                </div>
            </div>
            <Footer />
        </React.Fragment>
    );
};
export default BookingList;
